import { render } from "./Personnel.vue?vue&type=template&id=615bea90&scoped=true"
import script from "./Personnel.vue?vue&type=script&lang=js"
export * from "./Personnel.vue?vue&type=script&lang=js"

import "./Personnel.vue?vue&type=style&index=0&id=615bea90&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-615bea90"

export default script